const logger = console
export default logger
